import React from 'react';

import { Account, GUID } from '@ndvr/portfolio-api';

import { formatCurrency } from 'utils';
import { cn } from 'utils/cn';

import { useAccountPortfolio } from './useAccountPortfolio';

interface AccountNavCashProps {
    accountGUID: GUID<Account>;
    className?: string;
}

export const AccountNavCash = ({ accountGUID, className }: AccountNavCashProps) => {
    const { data: portfolio } = useAccountPortfolio(accountGUID);

    const { nav, cash } = portfolio?.base ?? {};

    return (
        <div className={cn('flex gap-6 text-sm', className)}>
            <div className="flex items-center gap-2">
                <span className="text-muted-foreground">Net Asset Value:</span>
                <span className="font-medium">{nav ? formatCurrency(nav) : '-'}</span>
            </div>
            <div className="flex items-center gap-2">
                <span className="text-muted-foreground">Cash:</span>
                <span className="font-medium">{cash ? formatCurrency(cash) : '-'}</span>
            </div>
        </div>
    );
};
